// Option.js
import React from "react";
import { TouchableOpacity, View, Text } from "react-native";
import styles from "../styles/profileStyle";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";

type OptionProps = {
  label: string;
  selected: boolean;
  onPress: () => void;
};

const CircleDesign = () => {
  return (
    <View style={[styles.optionCircle, styles.optionOnSelect]}>
      <View style={styles.optionCircleInner} />
    </View>
  );
};

const OptionRadio: React.FC<OptionProps> = ({ label, selected, onPress }) => {
  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <View style={styles.optionBoxInnerBox}>
        <Text style={[GlobalStyles.bodyText,{maxWidth:'90%',
          fontFamily: 'InterMedium', letterSpacing: -0.36, color: "#737373",
      }]}>{label}</Text>
        {selected ? <CircleDesign /> : <View style={styles.optionCircle} />}
      </View>
    </TouchableWithoutFeedback>
  );
};

export default OptionRadio;
